import React from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./style.css";
import Fitness1 from "../../Assets/Images/Fitness11.png";
import fitness_image2 from "../../Assets/Images/fitness_image2.png";
import fitness_image3 from "../../Assets/Images/fitness_image31.png";
import fitness_image4 from "../../Assets/Images/new/t5.png";
import Fitness21 from "../../Assets/Images/Fitness211.png";
import Fitness22 from "../../Assets/Images/Fitness22.png";
import Fitness23 from "../../Assets/Images/Fitness231.png";
import Fitness24 from "../../Assets/Images/Fitness24.png";

import fitness_banner_image from "../../Assets/Images/fitness_banner_image.png";
import Features from "../../Components/Features";
import Testimonial from "../../Components/Testimonial";
import dribbling from "../../Assets/Images/dribbling.png";
import shooting from "../../Assets/Images/shooting.png";
import passing from "../../Assets/Images/passing.png";
import defense from "../../Assets/Images/defense.png";
import rebounding from "../../Assets/Images/rebounding.png";
import stock_photo from "../../Assets/Images/stock_photo.png";
import Icon1 from "../../Assets/Icons/PCBIcon";
import Icon2 from "../../Assets/Icons/FGSBIcon";
import Icon3 from "../../Assets/Icons/TNFBIcon";
import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

export default function Fitness() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };
  return (
    <>
      <SEO
        title="Instruction | Fitness | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/fitness"
      />
      <div className="fitness-container">
        <div className="fitness-header filter-brightness">
          <div className="base-sec">
            <div>
              <span className="fitness-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="fitness-header-content">
              <h1 className="black-text-clip">Fitness</h1>
              <h3 className="black-text-clip">
                Transform Your Strength and Agility with BWC Fitness!
              </h3>
              <h5 className="black-text-clip">
                Get Fit, Stay Strong, and Feel Your Best with Staten Island’s
                Premier Training Program
              </h5>
              <p className="black-text-clip">
                Whether you’re looking to build strength, improve agility, or
                just feel more confident in your body, BWC Fitness has got you
                covered. Led by the incredible Nina Romano, our program is
                designed to meet you where you are and help you reach your
                personal fitness goals. It’s time to take your fitness journey
                to the next level!
              </p>
            </div>
          </div>
        </div>
        <div className="fitness-booking-container">
          {/* <button className="one-on-one">Schedule 1-on-1 Class Here</button> */}
          <button
            className="one-on-one black-text-clip"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule for Classes Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one fitness-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              <span>Sign Up for Classes Here</span>
            </button>
          )}
        </div>
        <div className="fitness-image-container">
          <img src={Fitness1} alt="soccer-image" />
          <img src={fitness_image2} alt="soccer-image" />
          <img src={fitness_image3} alt="soccer-image" />
          <img src={fitness_image4} alt="soccer-image" />
        </div>
        <div className="fitness-section2">
          <h3 className="black-text-clip">Why Choose BWC Fitness?</h3>
          <p className="black-text-clip">
            At BWC Fitness, we believe that fitness is for everyone, regardless
            of age, ability, or experience. Our program, located at the
            state-of-the-art Inoxx Fitness facility, offers a welcoming
            environment with top-tier equipment and personalized training that’s
            tailored to your individual needs.
          </p>
        </div>

        {/* <Features color="#474d52" Icon1={PCBIcon} Icon2={FGSBIcon} Icon3={TNFBIcon}/> */}
        <div className="features-container">
          <div
            className="features-card"
            style={{ border: `2px solid #7d8895` }}
          >
            <div
              className="features-icon"
              style={{ border: `2px solid #7d8895` }}
            >
              {Icon1 && <Icon1 className="features-icon-tag" />}
            </div>
            <h2
              className="black-text-clip"
              style={{ "--clip-color": "#282828" }}
            >
              Personalized Coaching
            </h2>
            <p className="black-text-clip">
              Because your game is unique, and so is our approach.{" "}
            </p>
          </div>
          <div
            className="features-card"
            style={{ border: `2px solid #7d8895` }}
          >
            <div
              className="features-icon"
              style={{ border: `2px solid #7d8895` }}
            >
              {Icon2 && <Icon2 className="features-icon-tag" />}
            </div>
            <h2
              className="black-text-clip"
              style={{ "--clip-color": "#282828" }}
            >
              Fun Group Sessions
            </h2>
            <p className="black-text-clip">
              Learn and laugh with others who love the game as much as you do.
            </p>
          </div>
          <div
            className="features-card"
            style={{ border: `2px solid #7d8895` }}
          >
            <div
              className="features-icon"
              style={{ border: `2px solid #7d8895` }}
            >
              {Icon3 && <Icon3 className="features-icon-tag" />}
            </div>
            <h2
              className="black-text-clip"
              style={{ "--clip-color": "#282828" }}
            >
              Top Notch Facilities
            </h2>
            <p className="black-text-clip">
              Practice with the best equipment in a welcoming environment.
            </p>
          </div>
        </div>

        <div className="fitness-section3">
          <h3 className="black-text-clip text-center">What We Offer</h3>
          <p className="black-text-clip">
            Our training programs are designed to cover all key aspects of track
            and field, ensuring that each athlete develops the skills needed for
            success:
          </p>
          <div className="soccer-section3-image-container">
            <div className="sc-card">
              <img src={Fitness21} alt="Strength Training" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Strength Training</div>
                <div className="sc-card-desc">
                  From free weights to resistance machines, build muscle and
                  boost your metabolism.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Fitness22} alt="Agility Drills" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Agility Drills</div>
                <div className="sc-card-desc">
                  Improve your coordination, balance, and quickness with
                  dynamic, functional movements.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Fitness23} alt="Cardio Conditioning<" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Cardio Conditioning</div>
                <div className="sc-card-desc">
                  Burn calories and improve your heart health with tailored
                  cardio sessions.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Fitness24} alt="Flexibility Work" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Flexibility Work</div>
                <div className="sc-card-desc">
                  Enhance your range of motion and prevent injuries with
                  stretching routines and mobility exercises.
                </div>
              </div>
            </div>

            {/* <div className="soccer_section_image_cont"><span className="skill-text-overlay">Passing</span><img src={soccerSkill1} alt="Shooting" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Shooting</span><img src={soccerSkill2} alt="Passing" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Defending</span><img src={soccerSkill3} alt="Defense" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Goal Keeping</span><img src={soccerSkill4} alt="Rebounding" /></div> */}
          </div>
        </div>
        <div className="fitness-section2">
          <h3 className="black-text-clip">
            Train in a State-of-the-Art Facility
          </h3>
          <p className="black-text-clip">
            Located at Intoxx Fitness, our program gives you access to
            top-of-the-line equipment in a clean, modern, and motivating
            environment. We’ve got everything you need to power through your
            workouts, from advanced strength machines to versatile functional
            training areas.
          </p>
        </div>

        <div className="testimonial-container">
          <h1 className="testimonial-header black-text-clip">
            WHAT PARENTS ARE SAYING
          </h1>
        </div>
        <Testimonial />
        <div className="fitness-booking-container2">
          <div className="fitness-booking-container-details">
            <h3 className="black-text-clip">Ready To Play fitness?</h3>
            <p>
              BWC Fitness stands out for our personalized approach and
              dedication to making fitness accessible and effective for
              everyone.
            </p>
            <p>
              <strong>Join the Team Now</strong> – Let’s make this season your
              best one yet!
            </p>
          </div>
          <div className="inside-booking-container">
            <button
              className="one-on-one one-btn"
              onClick={() => handleSubmit("1-1")}
              style={{ cursor: "pointer", backgroundColor: "#c3c3c3" }}
            >
              <span className="black-text-clip">Schedule Class Here</span>
            </button>
            {!user && (
              <button
                className="one-on-one two-btn fitness-booking-selected"
                onClick={() => handleSubmit("")}
                style={{ cursor: "pointer" }}
              >
                <span>Sign Up for Classes Here</span>
              </button>
            )}
          </div>
        </div>
        <div className="fitness-booking-container outside-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            onClick={() => handleSubmit("Group")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule for Classes Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one fitness-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>

        <div className="fitness-section4" style={{ alignItems: "center" }}>
          <h3 className="black-text-clip">WHY BWC FITNESS?</h3>
          <p className="black-text-clip">
            BWC Fitness stands out for our personalized approach and dedication
            to making fitness accessible and effective for everyone. We’re not
            just about lifting weights; we’re about lifting your confidence,
            energy, and quality of life.
          </p>
        </div>
        <div className="fitness-locations">
          <h3 className="black-text-clip">Locations</h3>
          <div className="fitness-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24263.718438824842!2d-74.236404!3d40.520269!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b55c671494eb%3A0x3be7db7cb0afdd2!2s236%20Richmond%20Valley%20Rd%2C%20Staten%20Island%2C%20NY%2010309!5e0!3m2!1sen!2sus!4v1773672683527!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="ss-card-description black-text-clip">
                <p>
                  <strong>Intoxx Fitness</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24257.108782780328!2d-74.232737!3d40.538527!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b53bcce49927%3A0x2674c8e9123c1037!2s32%20Carlin%20St%2C%20Staten%20Island%2C%20NY%2010309!5e0!3m2!1sen!2sus!4v1773672812307!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="ss-card-description black-text-clip">
                <p>
                  <strong>ELEV8 Fitness</strong>, New York
                </p>
              </div>
            </div>
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d24263.636638664924!2d-74.236945!3d40.520495!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b55c6776eb5d%3A0x7d6bc65085b677ea!2s236%20Richmond%20Valley%20Rd%20%2316%2C%20Staten%20Island%2C%20NY%2010309!5e0!3m2!1sen!2sus!4v1773672859463!5m2!1sen!2sus"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="ss-card-description black-text-clip">
                <p>
                  <strong>T.LC. Fitness</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
